module.exports = __webpack_public_path__ + "img/Macedonia.6ad3c751.png";